<template>
	<div class="Nav" @mouseleave="hideTitle()">
		<div v-for="(item1, index) in NavData" :key="index" :class="item1.disabled ? 'active' : 'item'" @mouseover="titleClick(item1, index)">
			<div class="text">
				<div>{{ item1.menuName }}</div>
			</div>
			<div v-if="item1.disabled" class="tankuang">
				<div>
					<div v-for="(item2, index) in item1.childMenu" :key="index" @click="ItemClick(item2)" :class="item2.disabled ? 't-true' : 'f-false'" class="tankuang-item">
						<div>{{ item2.menuName }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Menu',

	data() {
		return {
			activeIndex: '1',
			NavData: [
				{
					menuName: '桥梁管理',
					childMenu: [{ menuName: '' }]
				},
				{
					menuName: '数据管理',
					childMenu: [{ menuName: '' }]
				},
				{
					menuName: '巡察管理',
					childMenu: [{ menuName: '' }]
				},
				{
					menuName: '设备管理',
					childMenu: [{ menuName: '' }]
				},
				{
					menuName: '系统管理',
					childMenu: [{ menuName: '' }]
				}
			]
		};
	},
	components: {},
	mounted() {
		this.$store.state.menus.map(item => {
			item.disabled = false;
		});
		this.NavData = this.$store.state.menus;
		// console.log(JSON.parse(JSON.stringify(this.NavData)));
	},
	created() {},
	methods: {
		titleClick(item, index) {
			// if (item.disabled) {
			// 	this.NavData.map(ele => (ele.disabled = false));
			// } else {
			// 	this.NavData.map(ele => (ele.disabled = false));
			// 	item.disabled = true;
			// }
			console.log('进入');
			this.NavData.map(ele => (ele.disabled = false));
			item.disabled = true;
			this.$forceUpdate();
		},
		hideTitle(item, index) {
			this.NavData.map(ele => (ele.disabled = false));
			this.$forceUpdate();
		},
		//
		ItemClick(item) {
			console.log(item, item.route);
			if (!item.disabled) {
				this.$router.push(item.route);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.Nav {
	width: 90%;
	margin: 0 auto;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 20px;
	font-weight: 400;
	color: #90b6ff;
	.item {
		width: 154px;
		height: 70px;
		line-height: 70px;
		margin-top: 2px;
		text-align: center;
		background: url('../../assets/image/titleNew.png') no-repeat;
		background-size: 100% 100%;
		.text {
			position: relative;
			cursor: pointer;
			font-size: 18px;
			font-weight: 800;
			color: #fefefe;
		}
	}
	.active {
		width: 154px;
		height: 70px;
		line-height: 70px;
		margin-top: 2px;
		text-align: center;
		background: url('../../assets/image/titleNew.png') no-repeat;
		background-size: 100% 100%;
		.text {
			position: relative;
			cursor: pointer;
			font-size: 18px;
			font-weight: 800;
			color: #fefefe;
		}
	}
	.item:hover,
	.active:hover {
		background: url('../../assets/image/titleNew-hover.png') no-repeat;
		background-size: 100% 100%;
	}
}
.tankuang {
	position: absolute;
	z-index: -1;
	width: 160px;
	border: 1px solid transparent;
	background: linear-gradient(180deg, rgba(12, 69, 191, 0.9) 0%, rgba(10, 49, 144, 0.9) 94%, rgba(100, 134, 219, 0.9) 100%),
		linear-gradient(180deg, #0ee2de 0%, rgba(26, 45, 111, 0) 100%);
	border-radius: 4px;
	color: #f4faff;
	margin-top: 20px;
	bottom: 0;
	font-size: 14px;
	font-weight: 800;
	border-radius: 10px 10px 0 0;
	background-origin: border-box;
	background-clip: content-box, border-box;
	.tankuang-item {
		line-height: 60px;
		cursor: pointer;
		&::after {
			content: '';
			display: block;
			background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #6c96cd 48%, rgba(255, 255, 255, 0) 100%);
			height: 1px;
		}
	}
	.tankuang-item:hover {
		background: rgba(255, 255, 255, 0.2);
	}
	& > div {
		padding-bottom: 80px;
	}
	// .t-true {
	// 	cursor: not-allowed;
	// 	color: #666;
	// 	background: rgb(37, 71, 151);
	// }
	// .f-false {
	// 	color: #90b6ff;
	// }
	// .f-false:hover {
	// 	background: rgb(3, 16, 46);
	// 	color: #ddd;
	// }
}
// .Nav {
//   //position: absolute;
//   //top: 118px;
//   //left: 440px;
//   //width: 80px;
//   //height: 80px;
//   //z-index: 999;
//   //line-height: 40px;
//   //box-sizing: border-box;
//   //border-radius: 5px;
//   //color: white;
//   //background: #385BD1  ;
//   //background-size: 100% 100%;
//   //border: 1px solid #33BEC2 ;

//   // position: absolute;
//   // top: 118px;
//   // left: calc(50% - 250px);
//   // width: 500px;
//   // height: 50px;
//   // z-index: 999;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   .items {
//     position: relative;
//     background: #fff;
//     width: 120px;
//     height: 50px;
//     line-height: 50px;
//     background: rgba(21, 55, 135, 0.9);
//     background-size: 100% 100%;
//     border-radius: 5px;
//     font-size: 18px;
//     color: rgba(255, 255, 255, 100);
//     .itemChildren {
//       background: #ffffff;
//       color: #000000;
//       height: 40px;
//       line-height: 40px;
//       text-align: left;
//       text-indent: 0.1rem;
//       &:hover {
//         color: #ffffff;
//         background: rgba(21, 55, 135, 0.9);
//       }
//     }
//   }

//   .main {
//     // display: flex;
//     & > div {
//       text-align: center;
//       height: 50%;
//     }
//   }
// }

// .active {
//   background: #0f5790;
// }
// .chang {
//   border-bottom: 1px solid #33bec2;
//   font-size: 20px;
// }
// .chan1 {
//   font-size: 20px;
// }
</style>
